export default __webpack_public_path__ + "static/media/number1.d1fe156a.svg";